export enum Experiments {
  RECS_HIGHER_ON_MOBILE = 'pdp_dle_recs_higher_on_mobile',
}
